module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"OUTDOOR_CONFIGURE":"AIR EXTÉRIEUR - CONFIGURER","ANALYZERS":"CAPTEURS","name":"Nom","last_update":"Dernière mise à jour"},"en":{"OUTDOOR_CONFIGURE":"OUTDOOR - CONFIGURE","ANALYZERS":"ANALYZERS","name":"Name","last_update":"Last update"}}')
  delete Component.options._Ctor
}
